import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { setContribBiennaleMoraSanzioniListeners } from './contrib-biennale-mora-sanzioni.listeners';
import { setContribBiennaleDatiSorgenteListeners } from './contrib-biennale-dati-sorgente.listeners';
import { setContribBiennaleContributoListeners } from './contrib-biennale-contributo.listeners';

export class ContribBiennaleFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        setContribBiennaleMoraSanzioniListeners(this.form, this.store);
        setContribBiennaleDatiSorgenteListeners(this.form, this.store);
        setContribBiennaleContributoListeners(this.form, this.store);
    }
}
